import axios from "axios";
// import * as Jose from "node-jose";
import store from "@/store";
import * as C from "@/common";
import { Api } from "./api";

interface IMessageWithSuccess {
	/** successful */
	s: boolean;
}
interface IMessageWithUsername {
	/** Username */
	u: string;
}
interface IMessageWithUserId {
	/** Username */
	u: number;
}
interface IMessageWithCaptcha {
	/** Captcha */
	c: string;
}
interface IMessageWithPassword {
	/** Password */
	p: string;
}
interface IAuthRequest extends
	IMessageWithUsername,
	IMessageWithPassword {}
interface IAuthResponse {
	/** Token */
	t?: string;
}
interface IMessageWithToken {
	/** Token */
	t: string;
}
interface IAuthResponse extends
	Partial<IMessageWithToken> {}
interface IRegisterRequest extends
	IAuthRequest,
	IMessageWithCaptcha {}
interface IResetRequest extends
	IMessageWithUsername,
	IMessageWithCaptcha {}
interface ITokenRequest extends
	IMessageWithUserId,
	Partial<IMessageWithCaptcha>,
	IMessageWithToken,
	Partial<IMessageWithPassword> {

	/** Mode */
	m: string;
}

enum ApiMethod {
	Auth = "auth",
	Register = "register",
	Reset = "reset",
	Token = "token",
}

export class AuthApi extends Api {
	public constructor() {
		super();
	}

	public async authenticate(o: IAuthRequest): Promise<string | undefined> {
		const resp = await axios.post<IAuthResponse>(`${this.baseUrl}${ApiMethod.Auth}/`, o);
		store.commit("setToken", resp.data.t || undefined);

		return this.Token;
	}
	public async register(o: IRegisterRequest): Promise<void> {
		await this.executeWithErrorHandling(() => axios.post<IMessageWithSuccess>(`${this.baseUrl}${ApiMethod.Register}/`, o));
		return;
	}
	public async reset(o: IResetRequest): Promise<void> {
		await this.executeWithErrorHandling(() => axios.post<IMessageWithSuccess>(`${this.baseUrl}${ApiMethod.Reset}/`, o));
		return;
	}
	public async confirmToken(o: ITokenRequest) {
		await this.executeWithErrorHandling(() => axios.post<IMessageWithSuccess>(`${this.baseUrl}${ApiMethod.Token}/`, o));
		return;
	}

}
